/**
 * the fields that are used to create a custom post types
 */
import { POWChallengeI } from "./POWChallenge";

export interface CPTCreate {
  password: string;
  POWChallenge: Partial<POWChallengeI>;
  cpt: string;
}

/**
 * Model for Custom Post Type Creation
 */
export class CPTCreateModel implements CPTCreate {
  password = "";
  cpt = "";
  POWChallenge = {} as POWChallengeI;
}
